document.addEventListener('click', async (event) => {
  const clearBtn = event.target.closest('#Cart-ClearAll, .button-clear-cart');
  if (!clearBtn) return;

  event.preventDefault();

  // 1. Disable button
  clearBtn.setAttribute('disabled', 'true');
  clearBtn.classList.add('loading');

  // 2. Identify Dawn's cart-items component and main section elements
  const cartItems = document.querySelector('cart-items');
  const mainCartItemsSection = document.getElementById('main-cart-items');
  const sectionId = mainCartItemsSection?.dataset?.id || cartItems?.dataset?.id;

  // Show theme loading animation
  const loadingOverlay = cartItems?.querySelector('.loading-overlay');
  if (loadingOverlay) loadingOverlay.classList.remove('hidden');

  try {
    const rootUrl = window.Shopify?.routes?.root || '/';

    // 3. Request Shopify to clear the cart AND return fresh section HTML in one go
    // Note: includes main cart items, cart footer, and header counter bubble
    const sectionsToFetch = [
      sectionId,
      'main-cart-footer',
      'cart-icon-bubble'
    ].filter(Boolean).join(',');

    const response = await fetch(`${rootUrl}cart/clear.js?sections=${sectionsToFetch}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });

    if (!response.ok) throw new Error('Failed to clear cart');
    const data = await response.json();

    // 4. Update the Main Cart Page dynamically without reload
    if (data.sections) {
      // Re-render <cart-items> (Swaps table for "Your cart is empty" warning)
      if (sectionId && data.sections[sectionId]) {
        const parsedDoc = new DOMParser().parseFromString(data.sections[sectionId], 'text/html');
        const newCartItems = parsedDoc.querySelector('cart-items');
        if (newCartItems && cartItems) {
          cartItems.innerHTML = newCartItems.innerHTML;
          cartItems.classList.toggle('is-empty', true);
        }
      }

      // Hide or empty the cart footer (subtotal, checkout button, order notes)
      const cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) {
        cartFooter.classList.add('is-empty');
        cartFooter.style.display = 'none';
      }

      // Update header cart counter badge
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble && data.sections['cart-icon-bubble']) {
        const bubbleDoc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
        cartIconBubble.innerHTML = bubbleDoc.getElementById('cart-icon-bubble')?.innerHTML || '';
      }
    }

    // 5. Notify the theme's Pub/Sub system (so drawers & badges stay synced)
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'clear-all', cart: data });
    }

  } catch (error) {
    console.error('Error clearing cart:', error);
    clearBtn.removeAttribute('disabled');
    clearBtn.classList.remove('loading');
    if (loadingOverlay) loadingOverlay.classList.add('hidden');
  }
});



// cart pop up
document.addEventListener('click', async (event) => {
  // Target the Clear All button specifically inside cart-popup
  const clearBtn = event.target.closest('cart-popup #Cart-ClearAll, .rt-cart-popup .button-clear-cart');
  if (!clearBtn) return;

  event.preventDefault();

  const cartPopup = document.querySelector('cart-popup');
  if (!cartPopup) return;

  // 1. Prevent multiple rapid clicks and remove grey highlight states
  clearBtn.setAttribute('disabled', 'true');
  clearBtn.style.opacity = '0.5';
  clearBtn.style.pointerEvents = 'none';

  // 2. Target internal popup elements based on the exact DOM tree
  const popupItemsContainer = cartPopup.querySelector('#CartPopup-CartItems');
  const popupContentsWrapper = cartPopup.querySelector('.popup__contents');
  const clearBtnContainer = cartPopup.querySelector('.cart__clear-all-container');
  const popupFooter = cartPopup.querySelector('.popup__footer');
  const subtotalValue = cartPopup.querySelector('.totals__subtotal-value');
  const liveRegionText = cartPopup.querySelector('#CartPopup-LiveRegionText');

  // Display native loading state if available
  if (liveRegionText) liveRegionText.textContent = 'Clearing cart...';

  try {
    const rootUrl = window.Shopify?.routes?.root || '/';

    // 3. Clear cart items via official endpoint
    const response = await fetch(`${rootUrl}cart/clear.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });

    if (!response.ok) throw new Error('Failed to clear cart items');
    const updatedCart = await response.json();

    // 4. Update Popup UI immediately (without page reload)
    // A. Hide the Clear All button container
    if (clearBtnContainer) {
      clearBtnContainer.style.display = 'none';
    }

    // B. Replace the product table with the empty cart message
    const emptyMarkup = `
      <div class="cart--empty-block" style="text-align: center; padding: 2.5rem 1rem;">
        <h4 class="cart__empty-text" style="margin-bottom: 1.5rem;">Your cart is empty</h4>
        <a href="/collections/all" class="btn btn--primary">
          Continue shopping
        </a>
      </div>
    `;

    if (popupItemsContainer) {
      popupItemsContainer.innerHTML = emptyMarkup;
    } else if (popupContentsWrapper) {
      popupContentsWrapper.innerHTML = emptyMarkup;
    }

    // C. Hide checkout buttons, order notes, and accelerated payment buttons
    if (popupFooter) {
      popupFooter.style.display = 'none';
    }

    // D. Zero out subtotals (if still rendered anywhere)
    if (subtotalValue) {
      subtotalValue.textContent = 'Rs. 0.00';
    }

    // 5. Update the top navigation cart icon counter
    const sectionsRes = await fetch(`${window.location.pathname}?sections=cart-icon-bubble`);
    const sectionsData = await sectionsRes.json();
    if (sectionsData && sectionsData['cart-icon-bubble']) {
      const bubbleDoc = new DOMParser().parseFromString(sectionsData['cart-icon-bubble'], 'text/html');
      const freshBubble = bubbleDoc.getElementById('cart-icon-bubble');
      const currentBubble = document.getElementById('cart-icon-bubble');
      if (currentBubble && freshBubble) {
        currentBubble.innerHTML = freshBubble.innerHTML;
      }
    }

    // 6. Notify Shopify event bus so drawer/header listeners update cleanly
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'popup-clear-all', cart: updatedCart });
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: updatedCart } }));

  } catch (error) {
    console.error('Error clearing cart in popup:', error);
    clearBtn.removeAttribute('disabled');
    clearBtn.style.opacity = '1';
    clearBtn.style.pointerEvents = 'auto';

    const errorAlert = document.getElementById('CartPopup-CartErrors');
    if (errorAlert) {
      errorAlert.removeAttribute('hidden');
      errorAlert.textContent = 'Could not clear cart. Please try again.';
    }
  }
});